import { Component,Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';


@Component({
  selector: 'app-kycsuccess-dialog-component',
  templateUrl: './kycsuccess-dialog-component.component.html',
  styleUrls: ['./kycsuccess-dialog-component.component.scss']
})
export class KYCSuccessDialogComponentComponent implements OnInit {
  is2FA: boolean=false;

  constructor( 
    public dialogRef: MatDialogRef<KYCSuccessDialogComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private router: Router) { 
      console.log(data);
      if(data && data=='2fa'){
        this.is2FA=true;
      }
    }

  ngOnInit(): void {
  }


  closeModal(){
    this.dialogRef.close();
    localStorage.clear();  
    this.router.navigate(['/login']);
  
  }
  closeModal2fa(){
    this.dialogRef.close();
    this.router.navigate(['/dashboard']);
  
  }
}
